<template>
	<div>
		<h1>{{ titulo }}</h1>
		<v-dialog
		v-model="dialog"
		max-width="500px"
		>
			<v-container>
				<v-row>
					<v-card>
						<v-col class="pl-4 pr-4">
							<formReporte
							v-bind:referencia=editedItem.referencia
							v-bind:nombre=editedItem.nombre
							v-bind:rif_type=editedItem.rif_type
							v-bind:ci_rif=editedItem.ci_rif
							v-bind:banco_emisor=editedItem.banco_emisor
							v-bind:banco_receptor=editedItem.banco_receptor
							v-bind:monto=editedItem.monto
							v-bind:date=editedItem.fecha
							v-bind:formTitle=editedItem.formTitle
							v-bind:itemID=editedItem.id
							v-bind:rif_list=rif_list
							v-bind:bancos_e=bancos_e
							v-bind:bancos_r=bancos_r
							>
							</formReporte>
						</v-col>
					</v-card>
				</v-row>
			</v-container>
		</v-dialog>

		<v-card>
			<v-card-title>
				<v-text-field
				v-model="search"
				append-icon="mdi-magnify"
				label="Search"
				single-line
				hide-details
				></v-text-field>
			</v-card-title>
			<v-data-table
			:headers="headers"
			:items="datos"
			:search="search"
			:items-per-page="10"
			class="elevation-1"
			loading
			:loading-text="tableMessage"
			>
			<template
			v-slot:item.acciones="{ item }"
			>
			<v-card-actions>
				<v-icon
				small
				class="mr-2"
				@click="editItem(item)"
				>
				mdi-pencil
				</v-icon>
				<v-icon
				small
				@click="deleteItem(item)"
				>
				mdi-delete
				</v-icon>
	</v-card-actions>
	<v-dialog v-model="dialogDelete" max-width="500px">
		<v-card>
			<v-card-title class="headline">¿Seguro de que quieres eliminar este reporte?</v-card-title>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
				<v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
</v-data-table>
</v-card>
	<h2>Tabla</h2>
	<b-row>
		<b-card>
			<b-card-text>
				<b-table
				:items="datos"
				:fields="fields"
				:current-page="currentPage"
				:per-page="perPage"
				:filter="filter"
				:filter-included-fields="filterOn"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:sort-direction="sortDirection"
				stacked="md"
				show-empty
				small
				@filtered="onFiltered"
				></b-table>
			</b-card-text>
			<template #footer>
				<b-col sm="5" md="6" class="my-1">
					<b-form-group
					label="Per page"
					label-for="per-page-select"
					label-cols-sm="6"
					label-cols-md="4"
					label-cols-lg="3"
					label-align-sm="right"
					label-size="sm"
					class="mb-0"
					>
						<b-form-select
						id="per-page-select"
						v-model="perPage"
						:options="pageOptions"
						size="sm"
						></b-form-select>
					</b-form-group>
				</b-col>
				<b-col sm="7" md="6" class="my-1">
					<b-pagination
					v-model="currentPage"
					:total-rows="totalRows"
					:per-page="perPage"
					align="fill"
					size="sm"
					class="my-0"
					></b-pagination>
				</b-col>
			</template>
		</b-card>
	</b-row>
{{ errors }}
</div>
</template>
<script>
	//import axios from 'axios';
	import { mapState, mapMutations, mapActions } from "vuex";
	import formReporte from '@/components/reporteForm.vue';

	export default {
		components: {
			formReporte
		},
		props: {
			nombre: String,
			referencia: Number,
			rif_type: String,
			ci_rif: Number,
			banco_emisor: String,
			banco_receptor: String,
			monto: Number,
			date: Date,
			reporteID: Number
		},
		data() {
			return {
				search: '',
				token: '',
				formTitle: '',
				editedItemID: '',
				messages: '',
				messagesEdit: '',
				tableMessage: 'Recibiendo información, por favor espera...',
				errors: '',
				dialog: false,
				dialogDelete: false,
				titulo: 'Reportes',
				datos: [],
				headers: [
				{
					text: 'id',
					align: 'start',
					sortable: false,
					value: 'id',
				},
				{
					text: 'nombre',
					value: 'nombre',
					filter: value => {
						if (!this.nombre) return true

							return value
					},
				},
				{ text: 'referencia', value: 'referencia' },
				{ text: 'CI/Rif', value: 'ci_rif' },
				{ text: 'monto', value: 'monto' },
				{ text: 'Fecha', value: 'fecha' },
				{ text: 'Banco Emisor', value: 'banco_emisor' },
				{ text: 'Banco Receptor', value: 'banco_receptor' },
				{ text: 'Estado', value: 'status' },
				{ text: 'Acciones', value: 'acciones' },
				],
				fields: [
					{
						key: 'nombre',
						label: 'Nombre',
						sortable: true,
						sortDirection: 'desc'
					},
					{
						key: 'referencia',
						label: 'Referencia',
						sortable: true,
						class: 'text-center'
					},
					{
						key: 'ci_rif',
						label: 'CI/RIF',
						sortable: true,
						class: 'text-center'
					},
					{
						key: 'fecha',
						label: 'Fecha',
						sortable: true,
						class: 'text-center'
					},
					{
						key: 'monto',
						label: 'Monto',
						formatter: (value) => {
							return value
						},
						sortable: true,
						sortByFormatted: true,
						filterByFormatted: true
					},
					{
						key: 'acciones',
						label: 'Acciones'
					}
				],
				rif_list: [
					'V',
					'J',
					'G'
				],
				bancos_e: [
					'Mercantil',
					'Banesco',
					'Provincial',
					'Venezolano de Crédito',
				],
				bancos_r: [
					'Banesco',
					'Provincial',
					'Venezolano de Crédito',
				],
				editedIndex: -1,
				editedItem: {
					referencia: '',
					nombre: '',
					rif_type: '',
					ci_rif: 0,
					banco_emisor: null,
					banco_receptor: null,
					monto: 0,
					id: null,
					date: null
				},
				defaultItem: {
					referencia: '',
					ci_rif: 0,
					banco_emisor: 0,
					banco_receptor: 0,
				},
				totalRows: 1,
				currentPage: 1,
				perPage: 1,
				pageOptions: [1, 5, 10, 15, { value: 100, text: "Show a lot" }],
				sortBy: '',
				sortDesc: false,
				sortDirection: 'asc',
				filter: null,
				filterOn: [],
				infoModal: {
					id: 'info-modal',
					title: '',
					content: ''
				}
			}
		},
		computed: {
			...mapState([
				'loader',
				'server_url'
			]),
		},
		mounted(){
			this.get_reportes();
			this.totalRows = this.items.length
		},
		methods: {
			...mapMutations([
				'toggleLoader'
			]),
			...mapActions([
				'getReportes',
				'deleteReporte'
			]),
			async get_reportes() {
				this.toggleLoader(true);
				await this.getReportes().then( res => {
					this.toggleLoader(false);
					console.log(res.data.length);
					if(res.errors && res.errors.length > 0) {
						this.errors.push(res.error);
					} else {
						if(typeof res.data == 'string') {
							this.tableMessage = res.data;
						} else if(res.data.length > 0) {
							this.datos = res.data;
						} else {
							this.tableMessage = 'No se encontraron reportes';
						}
					}
				})
			},
			onFiltered(filteredItems) {
				// Trigger pagination to update the number of buttons/pages due to filtering
				this.totalRows = filteredItems.length
				this.currentPage = 1
			},
			editItem (item) {
				this.editedItem.referencia = item.referencia
				this.editedItem.nombre = item.nombre
				this.editedItem.rif_type = item.ci_rif.substring(0, 1)
				this.editedItem.banco_emisor = item.banco_emisor
				this.editedItem.banco_receptor = item.banco_receptor
				this.editedItem.monto = item.monto
				this.editedItem.fecha = item.fecha
				console.log('Fecha: ' + item.fecha);
				this.editedItem.ci_rif = item.ci_rif.substring(1)
				this.editedItem.formTitle = 'Editar Reporte #'+item.id
				this.editedItem.id = item.id
				this.editedIndex = this.datos.indexOf(item)
				this.editedItem.editedItem = Object.assign({}, item)
				this.dialog = true
			},
			deleteItem (item) {
				this.editedIndex = this.datos.indexOf(item)
				this.editedItem = Object.assign({}, item)
				this.dialogDelete = true
			},

			deleteItemConfirm () {
				this.datos.splice(this.editedIndex, 1)
				this.reporteID = this.editedItem.id;
				this.toggleLoader(true);
				this.closeDelete();
				this.delete(this.reporteID);
			},

			async delete (reporteID) {
				await this.deleteReporte(reporteID).then( response => {
					console.log(response);
					this.toggleLoader(false);
					if(response.status == 200) {
						this.messages = 'Reporte eliminado satisfactoriamente';
					}
					if(response.error && response.error.length > 0) {
						this.errors = response.error;
					} else {
						this.$router.push('reportes');
					}
				}).catch(error => {
					this.errors = error;
					console.log(error);
				})
			},

			close () {
				this.dialog = false
				this.$nextTick(() => {
					this.editedItem = Object.assign({}, this.defaultItem)
					this.editedIndex = -1
				})
			},

			closeDelete () {
				this.dialogDelete = false
				this.$nextTick(() => {
					this.editedItem = Object.assign({}, this.defaultItem)
					this.editedIndex = -1
				})
			},
			formatDate (date) {
				if (!date) return null

				const [year, month, day] = date.split('-')
				return `${day}/${month}/${year}`
			},
			/*save () {
				if (this.editedItemID > -1) {
					const BASEURL = this.settings.server_url;
					const ENDPOINT = '/reportes/2';

					const datos = {
						referencia: this.editedItem.referencia,
						nombre: this.editedItem.nombre,
						ci_rif: this.editedItem.rif_type + this.editedItem.ci_rif.padStart(9, "0"),
						banco_emisor: this.editedItem.banco_emisor,
						banco_receptor: this.editedItem.banco_receptor,
						monto: this.editedItem.monto,
						fecha: this.editedItem.date
					}
					console.log(datos);

					axios.create({
						baseURL: BASEURL,
						data: datos,
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer '+localStorage.token
						}
					})
					.put(ENDPOINT)
					.then(response => {
						this.messagesEdit = response.data;
						//this.close()
					});

					Object.assign(this.datos[this.editedIndex], this.editedItem)
				} else {
					this.datos.push(this.editedItem)
				}
			},*/
		},
		watch: {
			dialog (val) {
				val || this.close()
			},
			dialogDelete (val) {
				val || this.closeDelete()
			},
		}
	}
</script>